import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const commonDataModelEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-insight-global-configuration-common-data-model" */ './index.tsx'
			),
	),
	getPreloadProps: () => ({}),
});
